<template lang="pug">
  .container-dialog(v-if="playListItem" id="PlayListItemModify-container")
    el-header(
      @shortkey.native="keyboardShortcut",
      height='40px'
    )
      span
        MediumIcon(:medium="playList")
        span &nbsp; {{playList.type === 'PlayListDesktop' ? fullNameOfDesktopPlaylist(playList) : playList.name }}
      font-awesome-icon.slash(icon="chevron-right")
      span.bolder(v-if="playListItem.Medium")
        MediumIcon(:medium="playListItem.Medium")
        span &nbsp; {{playListItem.Medium.name}}
      hr.header
      el-tabs(type='border-card', v-model='activeTabName')
        el-tab-pane(name='PlayProperties' id="PlayListItemModify-playPropertiesPane")
          span(slot='label')
            font-awesome-icon(icon="palette")
            span &nbsp; {{$t('Display Properties')}}
          PlayListItemPlayProperties(
            id="PlayListItemModify-playProperties",
            :playListItem="playListItem",
            :playList="playList",
            @close='closePlayListItemModify()',
            @reloadPlayListItem='reloadPlayListItem()'
          )
        el-tab-pane(name='TimeRestrictions' id="PlayListItemModify-timeRestrictionsPane")
          span(slot='label')
            font-awesome-icon(icon="clock")
            span &nbsp; {{$t('Time restrictions')}}
          ScheduleDateEditor(
            id="PlayListItemModify-ScheduleDateEditor",
            :item='playListItem',
            model='PlayListItem',
            @close='closePlayListItemModify()',
            @reloadPlayListItem='reloadPlayListItem()')
          ScheduleDayTimeEditor(
            id="PlayListItemModify-ScheduleDayTimeEditor",
            :item='playListItem',
            model='PlayListItem',
            @close='closePlayListItemModify()',
            @reloadPlayListItem='reloadPlayListItem()'
          )
          ScheduleHolidayEditor(
            id="PlayListItemModify-ScheduleHolidayEditor",
            :item='playListItem',
            model='PlayListItem',
            @close='closePlayListItemModify()',
            @reloadPlayListItem='reloadPlayListItem()'
          )
        el-tab-pane(v-if='playList.type === "PlayListLayout" && modifyRestriction === "Zone"', name='Zone' id="PlayListItemModify-zonePane")
          span(slot='label')
            font-awesome-icon(icon="crop")
            span &nbsp; {{$t('Zone properties')}}
          SetPlayListItemZoneProperties(:playListItem="playListItem", :playList="playList", @close='closePlayListItemModify()')
        el-tab-pane(name='PlayerExeptions' id="PlayListItemModify-exceptionsPane")
          span(slot='label')
            font-awesome-icon(icon="ban")
            span &nbsp; {{$t('Exceptions')}}
          SetPlayListItemPlayerExeptions(:playListItem="playListItem", :playList="playList", @close='closePlayListItemModify()')
        el-tab-pane(name='Synchro' id="PlayListItemModify-synchronizationPane")
          span(slot='label')
            font-awesome-icon(icon="stopwatch")
            span &nbsp; {{$t('Synchronization')}}
          SetPlayListItemSynchroProperties(:playListItem="playListItem", :playList="playList", @close='closePlayListItemModify()')
        el-tab-pane(id="PlayListItemModify-configurePane" name='configurePlayListItem', v-if='playListItem.Medium.type === "PlayListExtended" || playListItem.Medium.type === "HTML5app"')
          span(slot='label')
            font-awesome-icon(icon="cogs")
            span &nbsp; {{$t('Configure')}}
          ExtensionConfigEditor(:playListItem="playListItem", :mediumId="playListItem.Medium.id", @close='closePlayListItemModify()')
</template>

<script>
// import Vue from 'vue'
import ScheduleDayTimeEditor from '../Common/ScheduleDayTimeEditor'
import ScheduleDateEditor from '../Common/ScheduleDateEditor'
import ScheduleHolidayEditor from '../Common/ScheduleHolidayEditor'
import SetPlayListItemZoneProperties from './SetPlayListItemZoneProperties'
import PlayListItemPlayProperties from './PlayListItemPlayProperties'
import SetPlayListItemSynchroProperties from './SetPlayListItemSynchroProperties'
import SetPlayListItemPlayerExeptions from './SetPlayListItemPlayerExeptions'
import ExtensionConfigEditor from './ExtensionConfigEditor'

import MediumIcon from '../Common/MediumIcon'
import textUtils from '../Common/textUtils.mixin'
export default {
  mixins: [textUtils],
  props: {
    'playListItem': {
      required: true
    },
    'playList': {
      required: true
    },
    'modifyRestriction': {
      required: true
    }
  },
  components: {
    ScheduleDayTimeEditor,
    ScheduleDateEditor,
    ScheduleHolidayEditor,
    SetPlayListItemZoneProperties,
    PlayListItemPlayProperties,
    SetPlayListItemSynchroProperties,
    SetPlayListItemPlayerExeptions,
    ExtensionConfigEditor,
    MediumIcon
  },
  created () {
    this.activeTabName = this.modifyRestriction
    console.log(this.modifyRestriction)
  },
  data () {
    return {
      errors: [],
      activeTabName: 'PlayProperties'
    }
  },
  methods: {
    itemHasDayTimeRestrictions (item) {
      return (item.PlayListItem_DaytimeRestrictions && item.PlayListItem_DaytimeRestrictions.length > 0)
    },
    itemHasDateRestrictions (item) {
      return (item.PlayListItem_DateRestrictions && item.PlayListItem_DateRestrictions.length > 0)
    },
    // END FIXME DRY
    itemHasZoneRestrictions (item) {
      return (item.width !== 1920 && item.width !== 0) || (item.height !== 1080 && item.height !== 0) || item.anchorX !== 0 || item.anchorY !== 0
    },
    itemHasPlayRestrictions (item) {
      return item.playDurationMs !== 0 || item.playOffsetMs !== 0 || item.objectFit !== 'fill'
    },
    itemHasSynchroRestrictions (item) {
      return item.broadcastSynchronize || item.listenSynchronize
    },
    itemHasPlayerExeptions (item) {
      if (!item.playForbiddenInMedia && !item.playOnlyInMedia) return false
      if (item.playForbiddenInMedia && JSON.parse(item.playForbiddenInMedia).length > 0) return true
      if (item.playOnlyInMedia && JSON.parse(item.playOnlyInMedia).length > 0) return true
      return false
    },
    reloadPlayListItem () {
      this.$emit('reloadPlayListItem')
      this.$emit('reloadPlaylist')
    },
    closePlayListItemModify () {
      this.$emit('close')
    },
    copyPlayListItemDaytimeRestrictions (restrictions) {
      this.$store.dispatch('Clipboard/setCopiedPlaylistitemDaytimeRestrictions', restrictions)
    },
    copyPlayListItemDateRestrictions (restrictions) {
      this.$store.dispatch('Clipboard/setCopiedPlaylistitemDateRestrictions', restrictions)
    },
    getClassForDayTimeTab (item) {
      if (this.itemHasDayTimeRestrictions(item)) return 'has-restriction'
      return 'hasnt-restriction'
    },
    getClassForZoneTab (item) {
      if (this.itemHasZoneRestrictions(item)) return 'has-restriction'
      return 'hasnt-restriction'
    },
    getClassForPlayTab (item) {
      if (this.itemHasPlayRestrictions(item)) return 'has-restriction'
      return 'hasnt-restriction'
    },
    getClassForSynchroTab (item) {
      if (this.itemHasSynchroRestrictions(item)) return 'has-restriction'
      return 'hasnt-restriction'
    },
    getClassForPlayerExeptionsTab (item) {
      if (this.itemHasPlayerExeptions(item)) return 'has-restriction'
      return 'hasnt-restriction'
    },
    getClassForDateTab (item) {
      if (this.itemHasDateRestrictions(item)) return 'has-restriction'
      return 'hasnt-restriction'
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .has-restriction {
    color: $--color-warning;
  }
  .slash {
    color: $--color-primary-light-1;
    font-weight: bold;
    padding: 0px 5px 0px 5px;
  }
  .modifications-section {
    border: 0px solid red;
  }
</style>



// WEBPACK FOOTER //
// src/components/Medium/PlayListItemModify.vue